import React, {useEffect} from "react";
import $ from 'jquery';
import {Link, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import {confirmAlert} from "../../Components/Alerts/BasicAlert";
import dayjs from "dayjs";
import {DATE_FORMAT, TIMESTAMP_FORMAT} from "../../Constants/Constants";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#coupons').DataTable({
      "ajax": {
        url: `${baseUrl}coupons`,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        {data: 'name', name: 'name'},
        {data: 'code', name: 'code'},
        {data: 'type', name: 'type'},
        {data: 'amount', name: 'amount'},
        {data: 'date_from', name: 'date_from'},
        {data: 'date_to', name: 'date_to'},
        {
          data: 'created_at',
          name: 'created_at',
          searchable: false,
          render: function (data, type, row) {
            return dayjs(row.created_at).format(TIMESTAMP_FORMAT)
          }
        },
        {
          data: 'actions',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                            
                             <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>
                    `;
          },
        },
      ],
      order: [[6, 'desc']],
    });

    table.on('click', 'button.actions', function () {
      $(this).next(".row-actions").fadeToggle().toggleClass("hidden-actions")
    });

    table.on('click', 'button.edit', function () {
      const id = $(this).attr("row-id");
      navigate(`/coupons/${id}/edit`);
    });

    table.on('click', 'button.delete', function () {
      const id = $(this).attr("row-id");
      confirmAlert('Do you want to delete?', () => {
        axios.delete(`/coupons/${id}`).then(res => {
          table.draw(false);
        });
      });
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, []);

  return (
    <div>
      <div className="d-flex flex-stack mb-5">
        <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
          <Link to='/coupons/create'
                className="btn btn-primary"
          >
            Add coupon
          </Link>
        </div>
      </div>

      <table id="coupons" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>Name</th>
          <th>Code</th>
          <th>Type</th>
          <th>Amount</th>
          <th>Start date</th>
          <th>End date</th>
          <th>Created at</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  );
}